// type
export default [
    {
        name: 'type',
        type: 'text-field',
        props: {
            label: 'Nombre',
        },
    },
]
